import React, { useEffect, useState } from 'react';

import Stepper from '../../component/Stepper/Stepper';
import AppHeader from '../../component/AppHeader/app-header';
import PricingSection from './components/PricingSection';
import { useStepper } from '../../hooks/useStepper';
import PageLoader from '../../component/PageLoader';
import { toast } from 'react-toastify';
import { fetchSubscriptionPlans } from '../../services/subscription';

const SubscriptionPlan = () => {
	const { steps, currentStep, goToStep } = useStepper();
	const [plans, setPlans] = useState([]);
	const [loading, setLoading] = useState(false);
	const [billing, setBilling] = useState('monthly');

	const getPlans = async () => {
		try {
			setLoading(true);
			const response = await fetchSubscriptionPlans();
			setPlans(response.plans);
		} catch (error) {
			console.error(error);
			toast.error('Failed to fetch subscription plans');
			setPlans([]);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getPlans();
	}, []);

	return (
		<main className="main-wrapper">
			<AppHeader
				title="Subscription Plan"
				username="Sanjay Choudhary"
			/>

			<div className="py-2">
				<Stepper
					steps={steps}
					currentStep={currentStep}
					onStepClick={goToStep}
				/>

				{loading ? (
					<PageLoader />
				) : (
					<PricingSection
						billing={billing}
						setBilling={setBilling}
						plans={plans}
					/>
				)}
			</div>
		</main>
	);
};

export default SubscriptionPlan;
